import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  EnvironmentSettings,
  ENVIRONMENT_SETTINGS,
} from '@epicuro-next/platform/environment';
import { IIntercomConfig } from './interfaces/intercom-config.interface';
import { INTERCOM_GONFIG_TOKEN } from './tokens';
import { IntercomService } from './services/intercom.service';

export function getIntercomConfig(
  environmentSettings: EnvironmentSettings,
): IIntercomConfig | null {
  if (!environmentSettings.intercomAppId) {
    return null;
  }

  return {
    appId: environmentSettings.intercomAppId,
  };
}

@NgModule({
  imports: [CommonModule],
  providers: [
    IntercomService,
    {
      provide: INTERCOM_GONFIG_TOKEN,
      useFactory: getIntercomConfig,
      deps: [ENVIRONMENT_SETTINGS],
    },
  ],
})
export class IntercomModule {}
